import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'hbo-confirmation-modal',
  templateUrl: './confirmation-modal.component.html',
  styleUrls: ['./confirmation-modal.component.scss']
})
export class ConfirmationModalComponent {

  @Input() id?: string | number;
  @Input() displayId?: string | number;
  @Output() confirm = new EventEmitter();
  @Output() cancel = new EventEmitter();


  @Input() head?: string;
  @Input() head5?: string;
  @Input() message?: string;
  @Input() extendedMessage?: string;
  @Input() cancelText?: string;
  @Input() confirmText?: string;
  @Input() hideFooter?: boolean;

  @Input() hideConfirm?: boolean;
  @Input() cancelAction?: string;

  @Output() initialized = new EventEmitter<void>();

  @Input() status?: string | number;

  ngAfterViewInit(){
    this.initialized.emit(); // notify parent it's rendered
  }


}
